import _ from 'lodash'
import { computed } from 'mobx'
import {
    Frozen,
    frozen,
    getSnapshot,
    model,
    Model,
    modelAction,
    modelFlow,
    prop,
    Ref,
    _async,
    _await,
} from 'mobx-keystone'
import { nanoid } from 'nanoid'
import LogRocket from 'logrocket'
import { createContext } from 'react'
import { runCreatePlansWorkspace } from './plansLifecycle'
import { firstWorldCountries } from './setWorld'
import { goToExternalLink } from '../screens/helpers/clicks'
import { subscribeToPlan } from './stripe'
import { shouldUseLogRocket } from '../helpers/random'

@model('fastwrite/PlansWorkspace')
export class PlansWorkspace extends Model({
    id: prop<string>(() => nanoid(9)),
    _version: prop(0),
    world: prop<string | null>(null),
    hasHydrated: prop<boolean>(false),
    plansData: prop<Frozen<any>>(),
    product: prop<string>('professional'),
}) {
    @modelAction
    hydrateDataFromPage() {
        const rootDiv = document.getElementById('root')
        const json = JSON.parse(rootDiv.dataset.hydrate)
        // console.log(json);
        const frozenJson = frozen(json)
        this.plansData = frozenJson
        // console.log(this.plansData.data)
        if (window.geoip2) {
            try {
                window.geoip2.country(
                    (response) => this.setIsThirdWorld(response),
                    this.setIsThirdWorldError,
                    {}
                )
            } catch {
                console.log('could not set country')
                this.setIsThirdWorldError()
            }
        } else {
            console.log('could not load geoip2')
            this.setIsThirdWorldError()
        }
        // console.log(this.currentProduct)
        this.hasHydrated = true
        // console.log("should use logrocket", this.plansData.data.shouldUseLogrocketDecimal)
        if (shouldUseLogRocket(this.plansData.data.shouldUseLogrocketDecimal)) {
            LogRocket.init('dgfgoi/fw')
            console.log(LogRocket)
            LogRocket.identify(this.id, {
                email: this.plansData.data.currentUserEmail,
            })
        }
    }
    @computed
    get currentProduct() {
        if (!this.hasHydrated) {
            return null
        }

        if (this.plansData.data == {}) {
            return null
        }
        return this.plansData.data.plans[this.product]
    }
    // @computed
    // get currentPlanSet() {
    //   if (this.product == "starter") {
    //     return "Starter (2000 Predictions)";
    //   } else {
    //     return "Professional (6000 Predictions)";
    //   }
    // }
    get planSets() {
        return ['Starter (2000 Predictions)', 'Professional (6000 Predictions)']
    }
    @modelAction
    togglePlanSet() {
        if (this.product == 'starter') {
            this.product = 'professional'
            return
        }
        this.product = 'starter'
    }

    @computed
    get shouldShowPlans() {
        if (this.world == null) {
            return false
        }
        if (this.currentProduct == null) {
            return false
        }
        return true
    }
    @computed
    get userHasLoggedIn() {
        if (!this.plansData.data.currentUserEmail) {
            return false
        }
        return true
    }
    @modelAction
    setIsThirdWorld(countryObj) {
        // console.log(countryObj)
        if (firstWorldCountries.includes(countryObj.country.iso_code)) {
            this.world = 'world_one'
        } else {
            this.world = 'world_three'
            this.product = 'professional'
        }
    }
    @modelAction
    setIsThirdWorldError() {
        this.world = 'world_one'
    }
    @modelAction
    makeEnvironmentKey() {
        if (this.plansData.data.isDevEnv) {
            return 'dev'
        }
        return 'prod'
    }
    @modelAction
    handleSubscriptionButtonClick(e, product, index) {
        console.log(index)
        console.log(product)
        console.log(this.userHasLoggedIn)
        console.log(
            'current user subscription plan',
            this.plansData.data.currentUserSubscriptionPlan
        )
        if (this.plansData.data.currentUserSubscriptionPlan) {
            goToExternalLink(e, '/plans', false)
            return
        }
        if (!this.userHasLoggedIn) {
            goToExternalLink(e, '/users/sign_up', false)
            return
        }
        const envKey = this.makeEnvironmentKey()
        const priceId =
            this.currentProduct[envKey]['price_ids'][this.world][index]
        const stripePublishableKey = this.plansData.data.stripePublishableKey
        const userStripeId = this.plansData.data.currentUserStripeId
        console.log(
            'making subscription request with',
            priceId,
            stripePublishableKey,
            userStripeId
        )
        subscribeToPlan(priceId, stripePublishableKey, userStripeId)
    }
}

const CreatedPlanWorkspace = runCreatePlansWorkspace()
// console.log('created plan workspace', getSnapshot(CreatedPlanWorkspace))
export const PlansWorkspaceContext =
    createContext<PlansWorkspace>(CreatedPlanWorkspace)

export interface PlansWorkspaceInterface {
    plansWorkspace: PlansWorkspace
}
